module.exports = __webpack_public_path__ + "static/customization-9758d828ca3e100c9b7c7ee9e26feffa.jpg";